import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"
import FanwordLightbox from '../scripts/lightbox';

export default class extends Controller {
  static targets = [  "modalBody", "modal","tagsModal", "promoteStoryButton", "promoteArticleButton", "recipientCheckbox",
                      "sendNotificationButton", "viewStoryButton", "viewArticleButton", "notificationRecipients" ]
  static values = {
    template: String,
    recipient: String,
    story: String,
    article: String
  }

  connect() {
    // console.log("Hello, Stories Interview Template Responses Controller here!", this.element)
    // console.log(this.modalTarget);
    // console.log(this.modalBodyTarget);
    // console.log(this.templateValue);

    this.modalTarget.addEventListener('hide.bs.modal', () => {
      this.stopPlayingMedia();
    });

    this.modalBodyTarget.addEventListener('hide.bs.tab', () => {
      this.stopPlayingMedia();
    }, true);

    // Check URL params for response_id and recipient_id
    const urlParams = new URLSearchParams(window.location.search)
    const responseId = urlParams.get('response_id')
    const recipientId = urlParams.get('recipient_id')

    // console.log("Response ID", responseId)
    // console.log("Recipient ID", recipientId)

    if (responseId && recipientId) {
      // Create modal instance bound to the modal element
      let modal = new bootstrap.Modal(this.modalTarget);
      modal.show()

      this.displayResults({ params: { recipient: recipientId, response: responseId } });
    }
  }

  // Pause video/audio so it does not keep playing after closing the modal or switching questions
  stopPlayingMedia() {
    this.modalTarget.querySelectorAll('video, audio').forEach((mediaElement) => {
      mediaElement.pause();
    });

    this.modalTarget.querySelectorAll('[id^="audio-button-"]').forEach((audioButton) => {
      audioButton.innerHTML = '<i class="fas fa-play fa-fw"></i> Replay Response';
    });
  }

  displayResults({ params }) {
    // console.log('Params', params);
    // console.log('Template value', this.templateValue);
    // console.log('Modal', this.modalTarget);
    // console.log('promoted?', params.promoted);

    if (params.story) {
      this.promoteStoryButtonTarget.classList.remove('d-block');
      this.promoteStoryButtonTarget.classList.add('d-none');

      this.viewStoryButtonTarget.classList.remove('d-none');
      this.viewStoryButtonTarget.classList.add('d-block');

      this.storyValue = params.story;
    }

    if (params.article) {

      if (this.hasPromoteArticleButtonTarget) {
        this.promoteArticleButtonTarget.classList.remove('d-block');
        this.promoteArticleButtonTarget.classList.add('d-none');
      }

      if (this.hasViewArticleButtonTarget) {
        this.viewArticleButtonTarget.classList.remove('d-none');
        this.viewArticleButtonTarget.classList.add('d-block');
      }

      this.articleValue = params.article;
    }

    if (!params.article && !params.story) {
      this.promoteStoryButtonTarget.classList.remove('d-none');
      this.promoteStoryButtonTarget.classList.add('d-block');

      this.viewStoryButtonTarget.classList.remove('d-block');
      this.viewStoryButtonTarget.classList.add('d-none');

      this.storyValue = null;
    }

    fetch(`/interview_templates/${this.templateValue}/recipients/${params.recipient}/responses`).then(res => res.text()).then(partial => {
      this.stopPlayingMedia();
      this.modalBodyTarget.innerHTML = "";
      this.modalBodyTarget.insertAdjacentHTML( 'beforeend', partial );

      this.recipientValue = params.recipient;

      FanwordLightbox.reloadLightbox('fanword-lightbox-image');

      if (params.response) {
        const response = this.modalBodyTarget.querySelector(`#recipient_question_${params.response}-tab`);
        // console.log("Response", response)
        response.click();
      }
    });
  }

  toggleAudio({ target, params }) {
    const audio = document.getElementById(`audio-${params.id}`);
    audio.addEventListener('ended', changeToPlayAtEnd, { once: true });

    function changeToPlayAtEnd() {
      target.innerHTML = '<i class="fas fa-play fa-fw"></i> Replay Response'
      this.removeEventListener('ended', changeToPlayAtEnd);
    }

    if (audio.paused) {
      audio.play();
      target.innerHTML = '<i class="fas fa-pause fa-fw"></i> Replay Response'
    } else {
      audio.pause();
      target.innerHTML = '<i class="fas fa-play fa-fw"></i> Replay Response'
    }
  }

  promote(event) {
    if (event.target.dataset.confirmSwal) {
      // need to confirm first
      return;
    }

    event.preventDefault();
    const type = event.target.dataset.type;
    const article_type_id = event.target.dataset.articleTypeId || null;

    if (type == 'article' && !article_type_id) {
      createAlert('danger', 'Please select an article type.');
      return;
    }

    fetch(`/interview_templates/${this.templateValue}/recipients/${this.recipientValue}/promote`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ type: type, article_type_id: article_type_id })
      }
    ).then((response) => {
        return response.json();
      })
      .then((data) => {

        if (data.type == 'story') {
          this.storyValue = data.new_id;

          this.promoteStoryButtonTarget.classList.add('d-none');

          this.viewStoryButtonTarget.classList.remove('d-none');
          this.viewStoryButtonTarget.classList.add('d-block');

          createAlert('info', 'Story created successfully.');

        } else if (data.type == 'article') {
          this.articleValue = data.new_id;

          this.promoteArticleButtonTarget.classList.add('d-none');

          this.viewArticleButtonTarget.classList.remove('d-none');
          this.viewArticleButtonTarget.classList.add('d-block');

          createAlert('info', 'Article created successfully.');
        }

      });
  }

  viewStory() {
    window.location = `/entity_admins/stories/${this.storyValue}`;
  }

  viewArticle() {
    window.location = `/entity_admins/articles/${this.articleValue}`;
  }

  export() {
    window.location = `/interview_templates/${this.templateValue}/recipients/${this.recipientValue}/export?format=txt`;
  }

  manageTags({ params }) {
    fetch(`/interview_templates/${this.templateValue}/recipients/${params.recipient}/tags`).then(res => res.text()).then(partial => {
      this.tagsModalTarget.innerHTML = "";
      this.tagsModalTarget.insertAdjacentHTML( 'beforeend', partial );

      // this.recipientValue = params.recipient;
    });
  }

}
